export default __webpack_public_path__ + "static/media/introducing.3ef1978a.jpg";